/* global bsBreakpoints jQuery Drupal drupalSettings */
(function ($, Drupal, drupalSettings) {
	'use strict';

	Drupal.behaviors.switchLang = {
		attach: function (context, drupalSettings) {
			$('.language-switcher-language-url')
				.not('.language-switcher-language-url--loaded')
				.each(function () {
					const switchLangBloc =
						document.querySelector(
							'.language-switcher-language-url'
						) || null;

					const allLinks = switchLangBloc.querySelectorAll('a');
					const links = switchLangBloc.querySelector('.links');
					links.setAttribute('aria-expanded', false);

					const langues =
						switchLangBloc.querySelectorAll('li') || null;

					const checkCurrentLang = () => {
						langues.forEach((lang) => {
							const dataLang = lang
								.querySelector('a')
								.getAttribute('hreflang');
							lang.querySelector('a').classList.add(
								dataLang + '-flag'
							);
							if (
								lang
									.querySelector('a')
									.classList.contains('is-active')
							) {
								lang.classList.add('is-active');
							}
						});
					};

					const keyboardNav = () => {
						// Pour tous les items du switch lang
						allLinks.forEach((item, index) => {
							// Si pas l'actif on set un tabindex négatif pour empecher d'y entrer
							if (!item.classList.contains('is-active')) {
								item.setAttribute('tabindex', '-1');
							}

							// Sinon on écoute la key enter, on prevent le lien actif et on affiche la list
							// Puis on retire les tabindex pour pouvoir naviguer dedans
							else {
								item.addEventListener('keydown', (e) => {
									if (e.key === 'Enter') {
										e.preventDefault();
										links.classList.toggle(
											'links--display'
										);
										const expanded =
											links.getAttribute('aria-expanded');
										console.log(typeof expanded, expanded);
										if (expanded === 'false') {
											links.setAttribute(
												'aria-expanded',
												true
											);
										} else {
											links.setAttribute(
												'aria-expanded',
												false
											);
										}
										allLinks.forEach((item) => {
											item.removeAttribute('tabindex');
										});
									}
								});
							}

							// On prévoit la fermeture de la liste avec echap
							item.addEventListener('keydown', (e) => {
								if (e.key === 'Escape') {
									links.classList.remove('links--display');
									links.setAttribute('aria-expanded', false);
								}
								if (!item.classList.contains('is-active')) {
									item.setAttribute('tabindex', '-1');
								}
							});

							// Si le dernier item est tab, on ferme la addEventListener
							if (index === allLinks.length - 1) {
								item.addEventListener('keydown', (e) => {
									if (e.key === 'Tab') {
										item.onblur = () => {
											links.classList.remove(
												'links--display'
											);
											links.setAttribute(
												'aria-expanded',
												false
											);
										};
									}
								});
							}
						});
					};

					const switchLang = () => {
						if (
							bsBreakpoints.detectBreakpoint() === 'xLarge' ||
							bsBreakpoints.detectBreakpoint() === 'large' ||
							bsBreakpoints.detectBreakpoint() === 'medium'
						) {
							switchLangBloc.addEventListener(
								'mouseleave',
								() => {
									links.classList.remove('links--display');
									switchLangBloc
										.querySelectorAll('a')
										.forEach((item) => {
											item.removeAttribute('tabindex');
										});
								}
							);
							switchLangBloc.addEventListener('mouseover', () => {
								links.classList.add('links--display');
								switchLangBloc
									.querySelectorAll('a')
									.forEach((item) => {
										item.setAttribute('tabindex', '1');
									});
								const menuResp = document.querySelector(
									'.header__menu__responsive'
								);
								const menuToggle = document.querySelector(
									'.header__menu__toggle'
								);
								if (!menuResp.contains(links)) {
									// eslint-disable-next-line no-unused-expressions
									menuResp.classList.contains('active')
										? menuResp.classList.remove('active')
										: '';
									// eslint-disable-next-line no-unused-expressions
									menuToggle.classList.contains('active')
										? menuToggle.classList.remove('active')
										: '';
								}
							});
						}
						switchLangBloc.querySelectorAll('a').forEach((item) => {
							item.addEventListener('click', (e) => {
								if (item.classList.contains('is-active')) {
									e.preventDefault();
									links.classList.toggle('links--display');
								}
							});
						});
					};

					const respSwitch = () => {
						if (bsBreakpoints.detectBreakpoint() === 'xSmall') {
							const menuResp = document.querySelector(
								'.header__menu__responsive'
							);
							menuResp.appendChild(switchLangBloc);
						} else {
							const menuDesk = document.querySelector(
								'.header__desktop__menu'
							);
							menuDesk.insertBefore(
								switchLangBloc,
								document.querySelector('.header__search')
							);
						}
					};

					const init = () => {
						if (switchLangBloc) {
							switchLangBloc.classList.add(
								'language-switcher-language-url--loaded'
							);
							checkCurrentLang();
							switchLang();
							keyboardNav();
							respSwitch();
							window.addEventListener('resize', () => {
								switchLang();
								respSwitch();
							});
						}
					};

					init();
				});
		},
	};
})(jQuery, Drupal, drupalSettings);
